export default {
  searchFilter: '',
  mappingSearchFilter: '',
  multiEntrySearchFilter: '',
  data: []
}
